const blogContext = require.context('./', false, /\.mdx$/);

export const blogPosts = blogContext.keys()
  .map((filePath) => {
    const module = blogContext(filePath);
    return {
      ...module.metadata,
      Component: module.default,
    };
  })
  .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));

export const blogBySlug = Object.fromEntries(
  blogPosts.map((post) => [post.slug, post])
);
